module.exports = __webpack_public_path__ + "static/media/Fullscreen-Off.de384abf.svg";